export default "__VITE_ASSET__Ds5dRv$N__"